import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';
import AdminReferrals from './AdminReferrals';
import AdminTickets   from './AdminTickets';
import { adminAPI } from '../../services/api';

export default function AdminApp() {
  const [admin, setAdmin] = useState(() => {
    // Auto-login if token + admin info already saved
    const saved  = localStorage.getItem('hcen_admin');
    const token  = localStorage.getItem('hcen_admin_token');
    if (saved && token) {
      try { return JSON.parse(saved); } catch { return null; }
    }
    return null;
  });

  // Hash-based subview routing (avoids touching the giant AdminPanel.js).
  // Open with: window.location.hash = '#referrals'
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const handleLogin = (adminData) => {
    localStorage.setItem('hcen_admin', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const handleLogout = () => {
    localStorage.removeItem('hcen_admin');
    localStorage.removeItem('hcen_admin_token');
    localStorage.removeItem('hcen_admin_refresh_token');
    localStorage.removeItem('hcen_admin_email');
    setAdmin(null);
  };

  // Any admin API 401 that could not be refreshed — return to login.
  useEffect(() => {
    const onExpired = () => setAdmin(null);
    window.addEventListener('hcen-admin-session-expired', onExpired);
    return () => window.removeEventListener('hcen-admin-session-expired', onExpired);
  }, []);

  // Soft session probe: adminCall auto-refreshes Cognito tokens on 401.
  // Only force logout when the session is truly dead (explicit session-expired
  // message AFTER a failed refresh) — avoid bouncing on transient network blips.
  useEffect(() => {
    if (!admin) return;
    let alive = true;
    adminAPI.getAnalytics().then((r) => {
      if (!alive) return;
      // Session-clearing is owned by adminCall → hcen-admin-session-expired.
      // Do not double-logout on generic errors (table missing, timeout, etc.).
      if (r.error && String(r.error).includes('Session expired')) {
        // Storage already wiped by adminCall; just sync React state.
        setAdmin(null);
      }
    });
    return () => { alive = false; };
  }, [admin]);

  const goBack = () => { window.location.hash = ''; };

  if (!admin) return <AdminLogin onLogin={handleLogin} />;
  if (hash === '#referrals') return <AdminReferrals onBack={goBack} />;
  if (hash === '#tickets')   return <AdminTickets   onBack={goBack} />;
  return <AdminPanel admin={admin} onLogout={handleLogout} />;
}
